export function deriveFilterState(graph, filters) {
  if (!graph) return { ops: [], visUnits: [], visMeters: [], labelMap: {} };

  const inter = (a, b) => new Set([...a].filter((x) => b.has(x)));
  const uni = (arr) => new Set(arr.flatMap((s) => [...s]));

  let allowedOps = new Set(graph.operatorCodes);
  let allowedUnits = new Set(graph.allUnits);
  let allowedMeters = new Set(graph.allMeters);

  if (filters.operator.length) {
    const uFromOps = filters.operator.map((op) => graph.unitsByOperator.get(op) ?? new Set());
    const mFromOps = filters.operator.map((op) => graph.metersByOperator.get(op) ?? new Set());
    allowedOps = new Set(filters.operator);
    allowedUnits = inter(allowedUnits, uni(uFromOps));
    allowedMeters = inter(allowedMeters, uni(mFromOps));
  }

  if (filters.unit.length) {
    const mFromUnits = filters.unit.map((u) => graph.metersByUnit.get(u) ?? new Set());
    const oFromUnits = new Set(filters.unit.map((u) => graph.operatorByUnit.get(u)));
    allowedUnits = inter(allowedUnits, new Set(filters.unit));
    allowedMeters = inter(allowedMeters, uni(mFromUnits));
    allowedOps = inter(allowedOps, oFromUnits);
  }

  if (filters.meter.length) {
    const uFromMeters = new Set(filters.meter.map((m) => graph.unitByMeter.get(m)));
    const oFromMeters = new Set(filters.meter.map((m) => graph.operatorByMeter.get(m)));
    allowedMeters = inter(allowedMeters, new Set(filters.meter));
    allowedUnits = inter(allowedUnits, uFromMeters);
    allowedOps = inter(allowedOps, oFromMeters);
  }

  return {
    ops: [...allowedOps],
    visUnits: [...allowedUnits].sort(),
    visMeters: [...allowedMeters].sort(),
    labelMap: Object.fromEntries([...allowedOps].map((code) => [code, graph.operatorLabelMap[code]])),
  };
}

export function trimFiltersToState(filters, state) {
  return {
    operator: filters.operator.filter((o) => state.ops.includes(o)),
    unit: filters.unit.filter((u) => state.visUnits.includes(u)),
    meter: filters.meter.filter((m) => state.visMeters.includes(m)),
  };
}
